import { BreakPointCondition, Text, useBreakpointIf, HStack, VStack } from '@genial/components';
import { Spacing, Typography, BoxBorder } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

namespace CustomerCardTypes {
  export type Props = {
    customerName: string;
    lastUpdate: string;
  };
}

export const CustomerCard: React.FC<CustomerCardTypes.Props> = ({ lastUpdate, customerName }) => {
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');

  if (isMobile) {
    return (
      <VStack
        testID="customer-card"
        borderRadius={BoxBorder.heavy}
        space={Spacing['inline.nano']}
        p={Spacing['inline.xxs']}
        bg={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
        <Text variant="bold" color="neutral.black" fontSize={Typography['fontsize.lg']}>
          {customerName}
        </Text>
        <HStack flex={1} alignItems="center" justifyContent={'space-between'} w={'full'}>
          <Text variant="semibold" color="neutral.medium" fontSize={Typography['fontsize.lg']}>
            Últ. atualização
          </Text>
          <Text variant="regular" color="neutral.medium" fontSize={Typography['fontsize.lg']}>
            {lastUpdate.split(' ')[0]}
          </Text>
        </HStack>
      </VStack>
    );
  }

  return (
    <VStack
      testID="customer-card"
      space={Spacing['inline.quarck']}
      borderRadius={BoxBorder.heavy}
      px={Spacing['inline.xxxs']}
      py={'20px'}
      bg={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
      <HStack flex={1} alignItems="center" justifyContent={'space-between'} w={'full'}>
        <Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.md']}>
          Nome
        </Text>
        <Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.md']}>
          Última atualização
        </Text>
      </HStack>
      <HStack flex={1} alignItems="center" justifyContent={'space-between'} w={'full'}>
        <Text variant="regular" color="neutral.darkest" fontSize={Typography['fontsize.md']}>
          {customerName}
        </Text>
        <Text variant="regular" color="neutral.darkest" fontSize={Typography['fontsize.md']}>
          {lastUpdate}
        </Text>
      </HStack>
    </VStack>
  );
};
